import styled, { css } from 'styled-components';

import { modalHeading, smallParagraph, nonResponsiveParagraph } from '../../../../theme/typography';
import { themeColor, themeZIndex, whenThemePropEqualsTrue } from '../../../../theme/getters';
import { media } from '../../../../theme/media';
import { Theme } from '../../../../modules/headerBar/themes';
import { basedOnHeaderTheme, headerTransition } from '../headerBar.styles';
import { square } from '../../../../theme/mixins';
import { TargetLink } from '../../targetLink';

export const Wrapper = styled.div``;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 79px; // 79px because 1px is border-top in List
  transform: translateX(100%);
  transition: transform ${headerTransition};
  background-color: ${themeColor('white')};

  ${whenThemePropEqualsTrue('isHamburgerOpen')(
    () => css`
      transform: translateX(0);
    `
  )}
`;

export const Nav = styled.nav`
  position: fixed;
  transform: translateX(100%);
  transition: transform ${headerTransition};
  top: 79px; // 79px because 1px is border-top in List
  left: 0;
  bottom: -50vh;
  right: 0;
  background-color: ${themeColor('white')};

  ${media.tablet`
    position: relative;
    left: auto;
    top: auto;
    right: auto;
    bottom: auto;
    padding-top: 0;
    transform: none;
    transition: none;
    background-color: ${themeColor('transparent')};
  `};

  ${whenThemePropEqualsTrue('isHamburgerOpen')(
    () => css`
      transform: translateX(0);
    `
  )}
`;

export const List = styled.ul`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 32px 24px;
  border-top: 1px solid ${themeColor('middleGray')};
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  ${media.tablet`
    flex-direction: row;
    margin: 0;
    padding: 0;
    border-top: none;
    overflow: visible;
  `};
`;

export const LinkItem = styled(TargetLink).attrs(() => ({ openExternalInNewTab: false }))``;

const itemBreak = '32px';

export const Item = styled.li`
  ${modalHeading};
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: color ${headerTransition};
  margin-bottom: 16px;

  &:before {
    content: '';
    display: ${({ withDot }) => (withDot ? 'block' : 'none')};
    cursor: default;
    position: absolute;
    ${smallParagraph};
    ${square('6px')};
    border-radius: 3px;
    left: -${itemBreak};
    transition: background-color ${headerTransition};
    margin-bottom: 0;
  }

  ${LinkItem} {
    width: 100%;
  }

  ${media.tablet`
    ${nonResponsiveParagraph};
    height: 32px;
    margin-right: ${itemBreak};
    margin-left: ${({ withDot }) => (withDot ? itemBreak : 0)};

    &:after {
      content: '';
      cursor: default;
      opacity: ${({ isActive }) => (isActive ? 1 : 0)};
      position: absolute;
      left: -8px;
      height: 1px;
      bottom: -24px;
      right: -8px;
      transition: opacity ${headerTransition}, background-color ${headerTransition};
      z-index: ${themeZIndex('overContent')}
    }

    &:last-child {
      margin-right: 0;
    }
  `};

  ${basedOnHeaderTheme({
    [Theme.LIGHT]: css`
      color: ${themeColor('white')};
      &:before,
      &:after {
        background-color: ${themeColor('white')};
      }

      ${media.tablet`
        color: ${themeColor('white')};
      `};
    `,
    [Theme.FILLED]: css`
      color: ${themeColor('primary')};
      &:before,
      &:after {
        background-color: ${themeColor('primary')};
      }
    `,
  })}}

  ${whenThemePropEqualsTrue('isHamburgerOpen')(
    () => css`
      color: ${themeColor('primary')};
    `
  )}
`;

export const FooterLinks = styled.ul`
  margin-top: 32px;
`;

export const FooterItem = styled.li`
  margin-bottom: 16px;
`;

export const FooterLink = styled(TargetLink)`
  color: ${themeColor('gray')};
`;
